import React from 'react';
import { Button } from 'semantic-ui-react';

import PrivateDataComponent from '../private-data-component';


const YoutubeImpressions = ({ latestStatistic, popupToggleHandler }) => {
  const insights = latestStatistic.insights;
  if (insights) {
    return (
      <Button
        color="red"
        inverted
        labelPosition="left"
        icon="pie graph"
        fluid
        content="view"
        onClick={() => popupToggleHandler(latestStatistic)}
        size="small"
      />
    );
  }
  return (
    <PrivateDataComponent />
  );
};

export default YoutubeImpressions;



/** WEBPACK FOOTER **
 ** ./src/components/youtube-impressions/index.js
 **/